export const AI_FEEDBACK_TYPE_PROMPT_IMPROVEMENT = "prompt-improvement";
export const AI_FEEDBACK_TYPE_CHAT_ANALYSIS = "chat-analysis";
export const AI_FEEDBACK_TYPE_MODEL_AUDIT = "model-audit";

export const NEW_PROJECT_AGGREGATION_PROMPT_SOURCE =
  "new-project/aggregation-and-model";
export const CHAT_ANALYSIS_FEEDBACK_SOURCE = "monitoring/chat-analysis";
export const MODEL_AUDIT_REFINE_SOURCE = "refine/model-audit";

export type AIFeedbackType =
  | typeof AI_FEEDBACK_TYPE_PROMPT_IMPROVEMENT
  | typeof AI_FEEDBACK_TYPE_CHAT_ANALYSIS
  | typeof AI_FEEDBACK_TYPE_MODEL_AUDIT;

export type AIFeedbackSeverity = "critical" | "high" | "medium" | "low";

export type AIFeedbackBaseItem = {
  sourcePrompt: string;
  id: string;
  feedbackType: AIFeedbackType;
  createdAt: string;
};

export type PromptImprovementFeedbackItem = AIFeedbackBaseItem & {
  feedbackType: typeof AI_FEEDBACK_TYPE_PROMPT_IMPROVEMENT;
  suggestion: string;
};

export type ChatAnalysisFeedbackItem = AIFeedbackBaseItem & {
  feedbackType: typeof AI_FEEDBACK_TYPE_CHAT_ANALYSIS;
  issueType: string;
  description: string;
  exampleSnippets: string[];
  severity: AIFeedbackSeverity;
  analyzedChatStartIndex: number;
  analyzedChatEndIndex: number;
};

/** One model-audit finding as an anonymous lesson; never carries names or numbers from the case. */
export type ModelAuditFeedbackItem = AIFeedbackBaseItem & {
  feedbackType: typeof AI_FEEDBACK_TYPE_MODEL_AUDIT;
  /** Rule id ("D1".."D19") for deterministic findings, "critic" for LLM ones. */
  rule: string;
  category: string;
  agentDid: string;
  shouldHave: string;
  /** `fixed` = the revision addressed it, `residual` = confirmed but shipped, `advisory` = recorded for calibration only. */
  resolution: "fixed" | "residual" | "advisory";
};

export type AIFeedbackItem =
  | PromptImprovementFeedbackItem
  | ChatAnalysisFeedbackItem
  | ModelAuditFeedbackItem;